import { create } from "zustand";
import { persist } from "zustand/middleware";
import {
  type CommandsSlice,
  createCommandsSlice,
} from "./slices/commands-slice";
import {
  createTerminalSlice,
  type TerminalSlice,
} from "./slices/terminal-slice";

export type Store = CommandsSlice & TerminalSlice;

export const useStore = create<Store>()(
  persist(
    (...a) => ({
      ...createCommandsSlice(...a),
      ...createTerminalSlice(...a),
    }),
    {
      name: "store",
    },
  ),
);
